import React from 'react';
import styled from 'styled-components';

import Logo from '../../Logo/Logo';
import NavItems from '../NavItems/NavItems';
import { Container } from '../../../../Hoc/elements';

const Header = styled.header`
  position: fixed;
  inset: 0 0 auto;
  z-index: 100;
  height: 4.6rem;
  background: rgba(255, 255, 255, 0.92);
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  box-shadow: 0 0.35rem 1.6rem rgba(0, 0, 0, 0.045);
  backdrop-filter: blur(20px);

  @media (max-width: 56rem) {
    display: none;
  }
`;

const Wrapper = styled(Container)`
  max-width: 90rem;
  height: 100%;
  padding-left: clamp(.75rem, 2.2vw, 2rem);
  padding-right: clamp(4.5rem, 6vw, 5.5rem);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
`;

const Navbar = ({ loggedIn }) => (
  <Header>
    <Wrapper>
      <Logo />
      <NavItems loggedIn={loggedIn} />
    </Wrapper>
  </Header>
);

export default Navbar;
